/* eslint-disable import/prefer-default-export */
import React from "react";
import styled from "styled-components";

import {
  CATEGORY_COLORS,
  CATEGORY_LABELS,
  MAP_COPY,
  MAP_FILTER_CATEGORIES,
} from "../../constants";
import { useMapUi } from "../../hooks/useMapUi";

const Container = styled.div`
  width: min(100%, 280px);
  padding: 16px;
  border-radius: ${({ theme }) => theme.borderRadius.lg}px;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: ${({ theme }) => theme.shadows.md3Level2};
`;

const Title = styled.h3`
  margin: 0 0 12px;
  font-size: 19px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text};
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
`;

const Dot = styled.span<{ $color?: string; $user?: boolean }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ $color, $user, theme }) =>
    $user ? theme.colors.surface : $color ?? "transparent"};
  border: ${({ $user }) => ($user ? "3px solid #3B82F6" : "none")};
  box-shadow: ${({ $user }) =>
    $user ? "0 0 0 4px rgba(59,130,246,0.2)" : "none"};
`;

const Label = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export function MapLegend() {
  const mapUi = useMapUi();

  return (
    <Container>
      <Title>{MAP_COPY.legendTitle}</Title>
      {MAP_FILTER_CATEGORIES.map((category) => (
        <Row key={category}>
          <Dot $color={CATEGORY_COLORS[category]} />
          <Label>{CATEGORY_LABELS[category]}</Label>
        </Row>
      ))}
      <Row>
        <Dot $user />
        <Label>{MAP_COPY.youAreHere}</Label>
      </Row>
      <Row>
        <Dot $color={mapUi.selectedPin} />
        <Label>{MAP_COPY.legendSelected}</Label>
      </Row>
    </Container>
  );
}
